
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jewelry",
      function () {
        return require("private-next-pages/jewelry/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jewelry"])
      });
    }
  